<template>
  <div>
    <v-alert
      :type="result && result.success === false ? 'error' : 'success'"
      dense
      outlined
      class="mb-4"
    >
      {{ resultMessage }}
    </v-alert>

    <operation-panel
      title="Uygulanan aksiyonlar"
      subtitle="Uygulanan Çözüm Planı"
      tone="success"
      chip-label="Sonuç"
      chip-color="success"
    >
      <operation-timeline
        :items="appliedActions"
        default-status="Uygulandı"
        default-color="success"
      />
    </operation-panel>
  </div>
</template>

<script>
import OperationPanel from "./OperationPanel.vue";
import OperationTimeline from "./OperationTimeline.vue";

export default {
  name: "OperationResultPanel",
  components: {
    OperationPanel,
    OperationTimeline,
  },
  props: {
    result: {
      type: Object,
      default: null,
    },
  },
  computed: {
    resultMessage() {
      if (!this.result) {
        return "Uygulama sonucu henüz yok. Backend uygulama endpoint'i bağlandığında sonuç özeti burada gösterilecek.";
      }

      return this.result.message || "Çözüm başarıyla uygulandı.";
    },
    appliedActions() {
      if (!this.result) {
        return [];
      }

      if (this.result.actions) {
        return this.result.actions;
      }

      const actions = [];

      if (this.result.relation) {
        actions.push({
          type: "Müşteri ilişkisi oluştur",
          label: `Müşteri ilişkisi #${this.result.relation.id} oluşturuldu`,
        });
      }

      if (this.result.product) {
        actions.push({
          type: "Ürün oluştur",
          label: `Ürün #${this.result.product.id} oluşturuldu`,
        });
      }

      return actions;
    },
  },
};
</script>
